import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetTenantIntegrationDocumentsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.TenantIntegrationDocumentFilterInput>;
}>;


export type GetTenantIntegrationDocumentsQuery = { __typename?: 'Query', integrations: Array<{ __typename?: 'TenantIntegrationDocument', integrationId: string, tenantId: string, source: Types.IntegrationSource, mySqlEndpoint?: string | null, mySqlUsername?: string | null, mySqlDatabase?: string | null, outboundInvoiceExportSupported: boolean }> };


export const GetTenantIntegrationDocumentsDocument = new TypedDocumentString(`
    query GetTenantIntegrationDocuments($where: TenantIntegrationDocumentFilterInput) {
  integrations(where: $where) {
    integrationId
    tenantId
    source
    mySqlEndpoint
    mySqlUsername
    mySqlDatabase
    outboundInvoiceExportSupported
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTenantIntegrationDocuments: build.query<GetTenantIntegrationDocumentsQuery, GetTenantIntegrationDocumentsQueryVariables | void>({
      query: (variables) => ({ document: GetTenantIntegrationDocumentsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTenantIntegrationDocumentsQuery, useLazyGetTenantIntegrationDocumentsQuery } = injectedRtkApi;
